module.exports = __webpack_public_path__ + "img/LogoNew.93bf2aad.png";